<ng-container *transloco="let t">
  @if (departments$ | async; as departments) {
    <pxc-list-picker
      class="h-56"
      data-testid="department-picker"
      [disabled]="isDepartmentChoiceDisabled"
      [emptyMessage]="
        clientCode === commonClientCode
          ? t('Cet espace ne contient aucun groupe : votre séquence sera privée.')
          : t('Cet espace ne contient aucun groupe : vous ne pouvez pas créer de séquence ici.')
      "
      [items]="departments"
      [selection]="departmentIds"
      (selectionChange)="departmentIdsChange.emit($event)">
      <pxc-client-picker
        class="w-full sm:max-w-80"
        data-testid="client-picker"
        [clients]="clients$ | async"
        [disabled]="isClientChoiceDisabled"
        [selectedClient]="clientCode"
        (selectedClientChange)="clientCodeChange.emit($event)" />
    </pxc-list-picker>
  }
  <div class="group mt-2 flex flex-col gap-1">
    <p class="text-sm text-text-tertiary group-has-[[error],tui-error:not(:empty)]:hidden">
      {{
        t('{ count, plural, =0 { Aucun groupe} =1 { # groupe} other { # groupes} }', { count: departmentIds.length })
      }}
    </p>
    <ng-content slot="[error]" />
  </div>
</ng-container>
